export default {
  countForecasts(state, counter) {
    state.forecast.counter = counter;
  }
};
